var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import React, { createContext, useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { RequestLoadingIndicator } from '../../../components/RequestLoadingIndicator';
import { SituacaoProcessoEnum } from '../../../enums/situacao-processo.enum';
import { addFuncionarioEdicaoInProcesso, removeFuncionarioEdicaoInProcesso, updateFuncionarioEdicaoInProcesso, } from '../../../services/processo-funcionario-edicao.service';
import { getServicoCredenciamentoByProcessoId } from '../../../services/processo.service';
import { getProcessoEdicaoById } from '../../../services/processo-edicao.service';
import { findAnaliseByProcessoEdicaoId } from '../../../services/analise-processo-edicao.service';
import { addOperadorEdicaoInProcesso, updateOperadorEdicaoInProcesso, removeOperadorEdicaoInProcesso, } from '../../../services/processo-operador-edicao.service';
import { addVeiculoEdicaoInProcesso, removeVeiculoEdicaoInProcesso, updateVeiculoEdicaoInProcesso, } from '../../../services/processo-veiculo-edicao.service';
var ProcessEdicaoContext = createContext(undefined);
export var ProcessEdicaoProvider = function (_a) {
    var children = _a.children;
    var params = useParams();
    var processoId = params.id ? Number(params.id) : undefined;
    var _b = useQuery({
        queryKey: ['processo', processoId],
        queryFn: function () { return getProcessoEdicaoById(processoId); },
        enabled: !!processoId,
    }), processo = _b.data, isFetchingProcesso = _b.isLoading;
    var _c = useQuery({
        queryKey: ['servico', processoId],
        queryFn: function () { return getServicoCredenciamentoByProcessoId(processo.processoId); },
        enabled: !!(processo === null || processo === void 0 ? void 0 : processo.processoId),
    }), servico = _c.data, isFetchingServico = _c.isLoading;
    var _d = useQuery({
        queryKey: ['analise', processoId],
        queryFn: function () { return findAnaliseByProcessoEdicaoId(processoId); },
        enabled: !!processo &&
            ((processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.AGUARDANDO_ANALISE ||
                (processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.APROVADO ||
                (processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.PENDENTE ||
                (processo === null || processo === void 0 ? void 0 : processo.situacao) === SituacaoProcessoEnum.REPROVADO),
    }), analise = _d.data, isFetchingAnalise = _d.isLoading;
    var addOperador = useCallback(function (operador) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addOperadorEdicaoInProcesso(processoId, operador)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var updateOperador = useCallback(function (operadorId, operador) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateOperadorEdicaoInProcesso(processoId, operadorId, operador)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var deleteOperador = useCallback(function (operadorId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeOperadorEdicaoInProcesso(processoId, operadorId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var addFuncionario = useCallback(function (funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addFuncionarioEdicaoInProcesso(processoId, funcionario)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var updateFuncionario = useCallback(function (funcionarioId, funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateFuncionarioEdicaoInProcesso(processoId, funcionarioId, funcionario)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var deleteFuncionario = useCallback(function (funcionarioId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeFuncionarioEdicaoInProcesso(processoId, funcionarioId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var addVeiculo = useCallback(function (veiculo) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addVeiculoEdicaoInProcesso(processoId, veiculo)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var updateVeiculo = useCallback(function (funcionarioId, veiculo) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateVeiculoEdicaoInProcesso(processoId, funcionarioId, veiculo)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var deleteVeiculo = useCallback(function (veiculoId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeVeiculoEdicaoInProcesso(processoId, veiculoId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var isLoading = isFetchingProcesso || isFetchingServico || isFetchingAnalise;
    return (_jsxs(ProcessEdicaoContext.Provider, { value: {
            servico: servico,
            processo: processo,
            analise: analise,
            addOperador: addOperador,
            updateOperador: updateOperador,
            deleteOperador: deleteOperador,
            addFuncionario: addFuncionario,
            updateFuncionario: updateFuncionario,
            deleteFuncionario: deleteFuncionario,
            addVeiculo: addVeiculo,
            updateVeiculo: updateVeiculo,
            deleteVeiculo: deleteVeiculo,
            isEditable: !!processo &&
                (processo.situacao === SituacaoProcessoEnum.RASCUNHO ||
                    processo.situacao === SituacaoProcessoEnum.PENDENTE),
            isLoading: isLoading,
        }, children: [_jsx(RequestLoadingIndicator, { loading: isLoading }), !isLoading && children] }));
};
export var useProcessEdicaoContext = function () {
    var context = useContext(ProcessEdicaoContext);
    if (!context) {
        throw new Error('useProcessEdicaoContext must be used within a ProcessEdicaoContext');
    }
    return context;
};
